<template>
  <el-form-item :label="$t('filters.tryOn')">
    <el-select
      v-model="tryOn"
      multiple
      :placeholder="$t('filters.chooseTryOn')"
      class="filterSelect"
      @change="tryChange"
    >
      <el-option
        v-for="item in tryOnOptions"
        :key="item.label"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
import {tryOnOptions} from '../utils/global'

export default {
  name: 'PickTryon',
  props: ['value'],
  mounted () {
  },
  computed: {
    tryOnOptions () {
      const lang = this.$store.getters.language
      return tryOnOptions[lang]
    },
  },
  data: function () {
    return {
      tryOn: this.value,
      // tryOnOptions: tryOnOptions,
    }
  },
  methods: {
    change: function () {
      console.log('同步更新')
      console.log('this.tryOn', this.tryOn)
      this.$emit('input', this.tryOn)
    },
    tryChange (val) {
      let len = val.length
      if (len > 1 && val[len - 1] === 'notTry') {
        this.tryOn = ['notTry']
      } else if (len === 2 && val[0] === 'notTry') {
        this.tryOn.shift()
      }
      this.change()
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.tryOn = val
    }
  }
}
</script>

<style lang="sass">
.filterConditionContainer
  .doorList
    height: 360px
    overflow: auto

</style>



// WEBPACK FOOTER //
// src/openSurvey/components/pickTryon.vue